var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H14C10.4212 0.00529018 6.9905 1.42931 4.4599 3.9599C1.92931 6.4905 0.50529 9.9212 0.5 13.5V26.5C0.5 30.0804 1.92232 33.5142 4.45406 36.0459C6.9858 38.5777 10.4196 40 14 40H27C30.5804 40 34.0142 38.5777 36.5459 36.0459C39.0777 33.5142 40.5 30.0804 40.5 26.5V13.5C40.4947 9.9212 39.0707 6.4905 36.5401 3.9599C34.0095 1.42931 30.5788 0.00529018 27 0ZM37.5 21H31.62L26.22 30.04C26.0405 30.3348 25.7878 30.5782 25.4864 30.7464C25.185 30.9147 24.8452 31.002 24.5 31H24.38C24.0125 30.9806 23.6575 30.8602 23.354 30.652C23.0505 30.4438 22.8104 30.1559 22.66 29.82L16.24 15.34L12.24 22.04C12.0605 22.3348 11.8078 22.5782 11.5064 22.7464C11.205 22.9147 10.8652 23.002 10.52 23H3.52V19H9.38L14.8 9.98C14.9888 9.66688 15.2599 9.41152 15.5837 9.24169C15.9076 9.07186 16.2717 8.99405 16.6367 9.01673C17.0017 9.03941 17.3534 9.16171 17.6537 9.37033C17.954 9.57895 18.1914 9.86591 18.34 10.2L24.78 24.68L28.78 17.98C28.957 17.6814 29.2087 17.4341 29.5102 17.2623C29.8118 17.0904 30.1529 17.0001 30.5 17H37.5V21Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagIcon);
export default __webpack_public_path__ + "static/media/diagIcon.5d80dbd82d4c87272827493fee1eab78.svg";
export { ForwardRef as ReactComponent };